import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import {
  PopoverOnboarding,
  spacer24,
  Type,
  ButtonTertiary,
} from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';

const StyledPopoverOnboarding = styled(PopoverOnboarding)`
  position: absolute;
  margin-top: ${spacer24};
  z-index: 1;
`;

interface OnboardingPopoverTwoProps {
  setOnboardingStep: Dispatch<SetStateAction<number | null>>;
  onComplete: () => void;
}

export const OnboardingPopoverTwo = ({
  setOnboardingStep,
  onComplete,
}: OnboardingPopoverTwoProps) => {
  const t = useT();

  return (
    <StyledPopoverOnboarding
      data-testid="onboarding"
      id="onboardingStepTwo"
      arrow="topStart"
      popoverTitle={t(
        'atlas.catalog_exports.walk_through.choose_your_date_range',
        'Choose your date range',
        'Title of walkthrough popover',
      )}
      colorSet="mutedAccent"
      onClose={() => onComplete()}
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      paginationText={
        <Type as="p" semanticColor="textSubdued" variant="finale">
          {t(
            'atlas.walk_through.two_of_three',
            '2 of 3',
            'Indicates this is two of three directions. 2 and 3 should be kept as numbers',
          )}
        </Type>
      }
      footerButton={
        <ButtonTertiary
          condensed
          size="small"
          onClick={() => {
            setOnboardingStep(3);
          }}
        >
          {t('atlas.actions.next', 'Next', 'Button text to go to next step')}
        </ButtonTertiary>
      }
    >
      {t(
        'atlas.catalog_exports.walk_through.choose_a_date_range',
        'Choose a date range for specific updates and inserts or "all time" to export your full catalog.',
        'Text in walkthrough popover',
      )}
    </StyledPopoverOnboarding>
  );
};
